<div class="d--f jc--c">
  <h2>{{ agreement.name }}</h2>
</div>
<div class="ml-2 mr-2" [innerHTML]="agreement.content"></div>
